import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'anihis-potvrda-blanko',
  templateUrl: './potvrda-blanko.component.html',
  styleUrls: ['./potvrda-blanko.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PotvrdaBlankoComponent {
  @Output() formChange = new EventEmitter<any>();

  form: FormGroup = new FormGroup({
    title: new FormControl(''),
    note: new FormControl(''),
    veterinarianName: new FormControl(''),
  });

  get title(): FormControl {
    return this.form.get('title') as FormControl;
  }

  get note(): FormControl {
    return this.form.get('note') as FormControl;
  }

  get veterinarianName(): FormControl {
    return this.form.get('veterinarianName') as FormControl;
  }

  clearForm() {
    this.form.reset();
  }
}
